import { MagicConfigMixin, duration } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var TimeSegment;
(function(TimeSegment2) {
  TimeSegment2["DAYS"] = "days";
  TimeSegment2["HOURS"] = "hours";
  TimeSegment2["MINUTES"] = "minutes";
  TimeSegment2["SECONDS"] = "seconds";
})(TimeSegment || (TimeSegment = {}));
let CountdownComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.intervalId = null;
    this.emittedTime = null;
    this.durationRemaining = {};
  }
  get digits() {
    return this.activeSegments.map((segment) => this.durationRemaining[segment].value);
  }
  get labels() {
    return this.activeSegments.map((segment) => this.durationRemaining[segment].name);
  }
  get asString() {
    const asString = this.activeSegments.map((segment) => {
      const key = `countdown.simple.label.${segment}`;
      if (this.meaningfulOnly && !this.durationRemaining[segment].isMeaningful) {
        return false;
      }
      return `${this.durationRemaining[segment].value}${this.$t(key)}`;
    });
    const joinedString = asString.filter((segment) => segment).join(" ");
    if (this.monospace) {
      return joinedString.replace(/\w|\s/g, '<span class="character">$&</span>');
    } else {
      return joinedString;
    }
  }
  get activeSegments() {
    return this.segments.split(",").map((segment) => segment.trim());
  }
  created() {
    this.intervalId = setInterval(() => {
      this.updateTime();
    }, 500);
  }
  destroyed() {
    clearInterval(this.intervalId);
  }
  updateTime() {
    if (this.to) {
      const timeLeft = this.to - Date.now() || 0;
      const { days, hours, minutes, seconds } = duration(timeLeft);
      this.durationRemaining = {
        [TimeSegment.DAYS]: {
          name: "days",
          value: this.padValue(Math.max(0, days)),
          isMeaningful: days > 0
        },
        [TimeSegment.HOURS]: {
          name: "hours",
          value: this.padValue(Math.max(0, hours)),
          isMeaningful: days > 0 || hours > 0
        },
        [TimeSegment.MINUTES]: {
          name: "minutes",
          value: this.padValue(Math.max(0, minutes)),
          isMeaningful: days > 0 || hours > 0 || minutes > 0
        },
        [TimeSegment.SECONDS]: {
          name: "seconds",
          value: this.padValue(Math.max(0, seconds)),
          isMeaningful: true
        }
      };
      if (timeLeft <= 0 && this.emittedTime !== this.to) {
        this.emittedTime = this.to;
        this.ended();
      }
    } else {
      this.durationRemaining = {
        [TimeSegment.DAYS]: {
          name: "days",
          value: "--",
          isMeaningful: false
        },
        [TimeSegment.HOURS]: {
          name: "hours",
          value: "--",
          isMeaningful: false
        },
        [TimeSegment.MINUTES]: {
          name: "minutes",
          value: "--",
          isMeaningful: false
        },
        [TimeSegment.SECONDS]: {
          name: "seconds",
          value: "--",
          isMeaningful: false
        }
      };
    }
  }
  padValue(value) {
    return value.toString().padStart(2, "0");
  }
  ended() {
    return;
  }
};
__decorateClass([
  Prop(Number)
], CountdownComponent.prototype, "to", 2);
__decorateClass([
  Prop(Boolean)
], CountdownComponent.prototype, "simple", 2);
__decorateClass([
  Prop({
    type: String,
    validator: (values) => {
      return !!values && values.split(",").map((value) => value.trim()).every((segment) => {
        return Object.values(TimeSegment).includes(segment);
      });
    },
    default: () => Object.values(TimeSegment).join(",")
  })
], CountdownComponent.prototype, "segments", 2);
__decorateClass([
  Prop(Boolean)
], CountdownComponent.prototype, "meaningfulOnly", 2);
__decorateClass([
  Prop(Boolean)
], CountdownComponent.prototype, "monospace", 2);
__decorateClass([
  Watch("to", { immediate: true })
], CountdownComponent.prototype, "updateTime", 1);
__decorateClass([
  Emit("ended")
], CountdownComponent.prototype, "ended", 1);
CountdownComponent = __decorateClass([
  Component({
    name: "countdown"
  })
], CountdownComponent);

export default CountdownComponent;
export { TimeSegment };
